import { render, staticRenderFns } from "./list_surveys_component.vue?vue&type=template&id=d12bb260&scoped=true"
import script from "./list_surveys_component.vue?vue&type=script&lang=js"
export * from "./list_surveys_component.vue?vue&type=script&lang=js"
import style0 from "./list_surveys_component.vue?vue&type=style&index=0&id=d12bb260&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12bb260",
  null
  
)

export default component.exports